var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 24.2992C19.241 24.2992 24.3002 19.24 24.3002 12.9992C24.3002 6.7584 19.241 1.69922 13.0002 1.69922C6.75938 1.69922 1.7002 6.7584 1.7002 12.9992C1.7002 19.24 6.75938 24.2992 13.0002 24.2992Z",
    stroke: "#47FDCA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.8984C9.5 15.8984 6.5 17.8984 5 20.8984C7 22.9984 9.9 24.1984 13 24.1984C16.1 24.1984 19 22.8984 21 20.8984C19.5 17.9984 16.5 15.8984 13 15.8984Z",
    stroke: "#47FDCA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 13.2977C14.9886 13.2977 16.6004 11.6859 16.6004 9.69766C16.6004 7.70943 14.9886 6.09766 13.0004 6.09766C11.0122 6.09766 9.40039 7.70943 9.40039 9.69766C9.40039 11.6859 11.0122 13.2977 13.0004 13.2977Z",
    stroke: "#47FDCA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bfccc456864d6e3fc243f068401dce32.svg";
export { ForwardRef as ReactComponent };